(function () {
    var halo = {
        _retryCount: 0,
        initSlideshow: function () {
            if (typeof window.syncHaloPlugins === 'function') {
                window.syncHaloPlugins();
            }

            var jq = window._haloVendorJQuery || window.jQuery || window.$;
            if (!jq || !jq.fn) {
                if (halo._retryCount < 20) {
                    halo._retryCount++;
                    setTimeout(halo.initSlideshow, 100);
                }
                return;
            }

            if (typeof jq.fn.slick !== 'function') {
                if (window._haloVendorSlick) {
                    jq.fn.slick = window._haloVendorSlick;
                } else {
                    if (halo._retryCount < 20) {
                        halo._retryCount++;
                        setTimeout(halo.initSlideshow, 100);
                    }
                    return;
                }
            }

            var slickSlideshow = jq('[data-init-slideshow]');
            if (!slickSlideshow.length) {
                return;
            }

            halo._retryCount = 0;

            slickSlideshow.each(function () {
                var self = jq(this);
                if (self.hasClass('slick-initialized')) return;

                var auto_playvideo = self.data('auto-video');
                var hasVideo = self.find('.item-video').length > 0;

                if (hasVideo && !window.YT) {
                    var tag = document.createElement('script');
                    tag.src = "https://www.youtube.com/iframe_api";
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    if (firstScriptTag && firstScriptTag.parentNode) {
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    } else {
                        document.head.appendChild(tag);
                    }
                }

                if (auto_playvideo && hasVideo) {
                    var postMessageToPlayer = function(player, command) {
                        if (player == null || command == null) return;
                        if (player.contentWindow) {
                            player.contentWindow.postMessage(JSON.stringify(command), "*");
                        }
                    };

                    var playPauseVideo = function(slick, control) {
                        var currentSlide = slick.find('.slick-current .item');
                        if (!currentSlide.length) return;
                        var player = currentSlide.find("iframe").get(0);
                        var video;

                        if (currentSlide.hasClass('slide-youtube')) {
                            var id = currentSlide.find('iframe').attr('id');
                            var video_id = currentSlide.find('iframe').data('video-id');
                            if (control === "play") {
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "playVideo"
                                });
                                if (typeof self.slick === 'function') self.slick('slickPause');
                                jq(player).off('ended.slideVideo').on('ended.slideVideo', function() {
                                    postMessageToPlayer(player, {
                                        "event": "command",
                                        "func": "playVideo"
                                    });
                                    if (typeof self.slick === 'function') {
                                        self.slick('slickPlay');
                                        self.slick('next');
                                    }
                                });
                            } else {
                                postMessageToPlayer(player, {
                                    "event": "command",
                                    "func": "pauseVideo"
                                });
                            }

                            if (window.YT && window.YT.Player) {
                                try {
                                    new YT.Player(id, {
                                        videoId: video_id,
                                        events: {
                                            'onReady': function(event) { event.target.playVideo(); },
                                            'onStateChange': function(event) {
                                                if (event.data === 0) {
                                                    postMessageToPlayer(player, { "event": "command", "func": "playVideo" });
                                                    if (typeof self.slick === 'function') {
                                                        self.slick('slickPlay');
                                                        self.slick('next');
                                                    }
                                                }
                                            }
                                        }
                                    });
                                } catch (e) {}
                            }
                        } else if (currentSlide.hasClass('slide-video')) {
                            video = currentSlide.find("video").get(0);
                            if (video != null) {
                                if (control === "play") {
                                    video.play();
                                    if (typeof self.slick === 'function') self.slick('slickPause');
                                    jq(video).off('ended.slideVideo').on('ended.slideVideo', function() {
                                        if (typeof self.slick === 'function') {
                                            self.slick('slickPlay');
                                            self.slick('next');
                                        }
                                    });
                                } else {
                                    video.pause();
                                }
                            }
                        }
                    };

                    self.on('init', function(event, slick) {
                        var $slider = jq(slick.$slider || self);
                        setTimeout(function(){
                            playPauseVideo($slider, "play");
                        }, 1000);
                    });

                    self.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
                        var $slider = jq(slick.$slider || self);
                        playPauseVideo($slider, "pause");
                    });

                    self.on("afterChange", function(event, slick, currentSlide) {
                        jq('.item.slick-slide:not(.slick-current) .fluid-width-video-wrapper .video').css('display', 'none');
                        jq('.slick-current .fluid-width-video-wrapper .video').css('display', 'block');
                        var $slider = jq(slick.$slider || self);
                        playPauseVideo($slider, "play");
                    });
                }

                self.on("mouseenter.slideshow focus.slideshow", function () {
                    jq('.home-slideshow .slideshow').addClass('over_hover');
                });

                var dotsSetting = self.data('dots');
                var dots = (dotsSetting !== 'none' && dotsSetting !== false);
                var isDotsNumber = (dotsSetting === 'number');
                var arrowsMobile = isDotsNumber;

                var isFade = self.data('fade');
                if (typeof isFade === 'string') isFade = (isFade === 'true');
                if (typeof isFade !== 'boolean') isFade = false;

                var isAutoplay = self.data('autoplay');
                if (typeof isAutoplay === 'string') isAutoplay = (isAutoplay === 'true');
                if (typeof isAutoplay !== 'boolean') isAutoplay = true;

                var autoplaySpeed = parseInt(self.data('autoplay-speed'), 10) || 3000;

                var isArrows = self.data('arrows');
                if (typeof isArrows === 'string') isArrows = (isArrows === 'true');
                if (typeof isArrows !== 'boolean') isArrows = true;

                var speed = parseInt(self.data('speed'), 10) || 500;

                var nextArrow = (window.arrows && window.arrows.icon_next) ? window.arrows.icon_next : '<button type="button" class="slick-next" aria-label="Next">Next</button>';
                var prevArrow = (window.arrows && window.arrows.icon_prev) ? window.arrows.icon_prev : '<button type="button" class="slick-prev" aria-label="Previous">Previous</button>';

                var slickConfig = {
                    dots: dots,
                    slidesToScroll: 1,
                    verticalSwiping: false,
                    fade: isFade,
                    cssEase: "ease",
                    adaptiveHeight: true,
                    autoplay: isAutoplay,
                    autoplaySpeed: autoplaySpeed,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    arrows: isArrows,
                    nextArrow: nextArrow,
                    prevArrow: prevArrow,
                    rtl: Boolean(window.rtl_slick),
                    speed: speed,
                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                arrows: arrowsMobile,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: arrowsMobile,
                                dots: true
                            }
                        }
                    ]
                };

                if (isDotsNumber) {
                    var customPaging = function(slickInst, i) {
                        var index = i + 1;
                        var count = slickInst.slideCount;
                        return '<a class="dot" aria-label="' + index + '/' + count + '">' + index + '/' + count + '</a>';
                    };
                    slickConfig.customPaging = customPaging;
                    slickConfig.responsive[0].settings.customPaging = customPaging;
                    slickConfig.responsive[1].settings.customPaging = customPaging;
                }

                self.slick(slickConfig);
            });
        }
    };

    window.haloInitSlideshow = halo.initSlideshow;

    function runInit() {
        halo.initSlideshow();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runInit);
    } else {
        runInit();
    }

    window.addEventListener('load', runInit);

    // Shopify Theme Editor support
    if (typeof document !== 'undefined') {
        document.addEventListener('shopify:section:load', function() {
            setTimeout(runInit, 100);
        });
        document.addEventListener('shopify:section:select', function() {
            setTimeout(runInit, 100);
        });
        document.addEventListener('shopify:block:select', function(e) {
            var jq = window._haloVendorJQuery || window.jQuery || window.$;
            if (!jq) return;
            var target = e.target;
            var $slideshow = jq(target).closest('[data-init-slideshow]');
            if ($slideshow.length && typeof $slideshow.slick === 'function' && $slideshow.hasClass('slick-initialized')) {
                var index = jq(target).data('index');
                if (typeof index !== 'undefined') {
                    $slideshow.slick('slickGoTo', parseInt(index, 10) - 1);
                }
            }
        });
    }
})();
